import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { License } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-logo',
    templateUrl: './app-logo.component.html',
})
export class AppLogoComponent {
    public readonly application = input.required<License.ApplicationEnum>();
    public applicationIconMap = {
        [License.ApplicationEnum.CONNECT_CONTROL]: 'assets/images/logo/logo_connect_control.svg',
        [License.ApplicationEnum.CONNECT_SERVICES]: 'assets/images/logo/logo_connect_services.svg',
        [License.ApplicationEnum.CONNECT_FIELD]: 'assets/images/logo/logo_connect_field.svg',
    };
    public readonly logoClasses = input<string>();
}
